import script from "./AppChangeNetwork.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppChangeNetwork.vue?vue&type=script&setup=true&lang=ts"

import "./AppChangeNetwork.vue?vue&type=style&index=0&id=fd02e54a&lang=css"

const __exports__ = script;

export default __exports__